import CajaMensualCrud from './CajaMensualCrud'
export {CajaMensualCrud}
export default CajaMensualCrud
